const data = [
  {
    userUuid: "usr_7b5c6223b654dc",
    lastVisit: 1660608000000,
    churnProbability: "0.8",
    memberSince: 1653436800000,
    name: "Praveen P",
    email: "test@test.com",
    reasons: [
      {
        score: 1.06,
        reason: "1 refunds in the last month",
      },
      {
        score: 0.63,
        reason: "2 transactions in the past six months",
      },
      {
        score: 0.61,
        reason: "1 views of the member app in the past three months",
      },
    ],
  },
  {
    userUuid: "usr_467e17e2fa403c",
    lastVisit: 1663027200000,
    churnProbability: "0.76",
    memberSince: 1647561600000,
    name: "Christine Hamlin",
    email: "test@test.com",
    reasons: [
      {
        score: 1.06,
        reason: "1 refunds in the last month",
      },
      {
        score: 0.61,
        reason: "1 views of the member app in the past three months",
      },
      {
        score: 0.5,
        reason:
          "We couldn't detect check-in data for this user (are you using check-ins regularly?)",
      },
    ],
  },
  {
    userUuid: "usr_b16976e6537e2d",
    lastVisit: 1662508800000,
    churnProbability: "0.72",
    memberSince: 1652832000000,
    name: "Mollie Rhodes",
    email: "test@test.com",
    reasons: [
      {
        score: 0.61,
        reason: "1 views of the member app in the past three months",
      },
      {
        score: 0.5,
        reason:
          "We couldn't detect check-in data for this user (are you using check-ins regularly?)",
      },
      {
        score: 0.42,
        reason: "We couldn't detect cancellation data for this user",
      },
    ],
  },
  {
    userUuid: "usr_7e3caa356fe8e9",
    lastVisit: 1652659200000,
    churnProbability: "0.47",
    memberSince: 1645920000000,
    name: "Karter Moore",
    email: "test@test.com",
    reasons: [
      {
        score: 0.5,
        reason:
          "We couldn't detect check-in data for this user (are you using check-ins regularly?)",
      },
      {
        score: 0.42,
        reason: "We couldn't detect cancellation data for this user",
      },
    ],
  },
  {
    userUuid: "usr_f76e94c29fc997",
    lastVisit: 1661990400000,
    churnProbability: "0.46",
    memberSince: 1635206400000,
    name: "Sandy Bemiss",
    email: "test@test.com",
    reasons: [
      {
        score: 0.76,
        reason: "2 views of the member app in the past three months",
      },
      {
        score: 0.5,
        reason:
          "We couldn't detect check-in data for this user (are you using check-ins regularly?)",
      },
    ],
  },
  {
    userUuid: "usr_a3120d27054300",
    lastVisit: 1655078400000,
    churnProbability: "0.4",
    memberSince: 1631750400000,
    name: "Jillian Wilson",
    email: "test@test.com",
    reasons: [
      {
        score: 0.61,
        reason: "1 views of the member app in the past three months",
      },
      {
        score: 0.5,
        reason:
          "We couldn't detect check-in data for this user (are you using check-ins regularly?)",
      },
    ],
  },
  {
    userUuid: "usr_2635d8e11ab764",
    lastVisit: 1662508800000,
    churnProbability: "0.42",
    memberSince: 1646697600000,
    name: "Eliezer Perez",
    email: "test@test.com",
    reasons: [
      {
        score: 0.61,
        reason: "1 views of the member app in the past three months",
      },
      {
        score: 0.5,
        reason:
          "We couldn't detect check-in data for this user (are you using check-ins regularly?)",
      },
      {
        score: 0.42,
        reason: "We couldn't detect cancellation data for this user",
      },
    ],
  },
  {
    userUuid: "usr_ccca62607b3e70",
    lastVisit: 1665187200000,
    churnProbability: "0.4",
    memberSince: 1657584000000,
    name: "Tim Payne",
    email: "test@test.com",
    reasons: [
      {
        score: 0.61,
        reason: "1 views of the member app in the past three months",
      },
      {
        score: 0.54,
        reason: "3 transactions in the past six months",
      },
      {
        score: 0.5,
        reason:
          "We couldn't detect check-in data for this user (are you using check-ins regularly?)",
      },
    ],
  },
  {
    userUuid: "usr_3941f1786c8aa0",
    lastVisit: 1659052800000,
    churnProbability: "0.44",
    memberSince: 1656979200000,
    name: "Brent Mertz",
    email: "test@test.com",
    reasons: [
      {
        score: 0.61,
        reason: "1 views of the member app in the past three months",
      },
      {
        score: 0.54,
        reason: "3 transactions in the past six months",
      },
      {
        score: 0.5,
        reason:
          "We couldn't detect check-in data for this user (are you using check-ins regularly?)",
      },
    ],
  },
  {
    userUuid: "d48256eacd7608dd788dde8c0e388060",
    lastVisit: 1661385600000,
    churnProbability: "0.49",
    memberSince: 1656460800000,
    name: "Brady Spencer",
    email: "test@test.com",
    reasons: [
      {
        score: 0.54,
        reason: "3 transactions in the past six months",
      },
      {
        score: 0.5,
        reason:
          "We couldn't detect check-in data for this user (are you using check-ins regularly?)",
      },
      {
        score: 0.42,
        reason: "We couldn't detect cancellation data for this user",
      },
    ],
  },
  {
    userUuid: "usr_c31b9e45084433",
    lastVisit: 1660521600000,
    churnProbability: "0.42",
    memberSince: 1652918400000,
    name: "Rachel Elyachar",
    email: "test@test.com",
    reasons: [
      {
        score: 0.61,
        reason: "1 views of the member app in the past three months",
      },
      {
        score: 0.5,
        reason:
          "We couldn't detect check-in data for this user (are you using check-ins regularly?)",
      },
      {
        score: 0.42,
        reason: "We couldn't detect cancellation data for this user",
      },
    ],
  },
  {
    userUuid: "usr_c4b19afb4f2646",
    lastVisit: 1665360000000,
    churnProbability: "0.46",
    memberSince: 1657238400000,
    name: "Debasis Mohapatra",
    email: "test@test.com",
    reasons: [
      {
        score: 0.61,
        reason: "1 views of the member app in the past three months",
      },
      {
        score: 0.54,
        reason: "3 transactions in the past six months",
      },
      {
        score: 0.5,
        reason:
          "We couldn't detect check-in data for this user (are you using check-ins regularly?)",
      },
    ],
  },
  {
    userUuid: "usr_bd1cbd85e81df8",
    lastVisit: 1663286400000,
    churnProbability: "0.54",
    memberSince: 1657584000000,
    name: "Maria Cardenas",
    email: "test@test.com",
    reasons: [
      {
        score: 0.61,
        reason: "1 views of the member app in the past three months",
      },
      {
        score: 0.54,
        reason: "3 transactions in the past six months",
      },
      {
        score: 0.5,
        reason:
          "We couldn't detect check-in data for this user (are you using check-ins regularly?)",
      },
    ],
  },
];

export default data;
